'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const jsxRuntime = require('react/jsx-runtime');
const designSystem = require('@zapier/design-system');
const PageHeader_PageHeaderBase = require('./PageHeaderBase.cjs.js');

const headerWrapper = "_header-wrapper_315x5_1";
const titleRow = "_title-row_315x5_7";
const titleContent = "_title-content_315x5_8";
const pageIcon = "_page-icon_315x5_18";
const title = "_title_315x5_7";
const pageTag = "_page-tag_315x5_41";
const responsiveTag = "_responsive-tag_315x5_46";
const actionsContainer = "_actions-container_315x5_52";
const defaultActions = "_default-actions_315x5_60";
const compactActions = "_compact-actions_315x5_64";
const additionalContent = "_additional-content_315x5_83";
const styles = {
	headerWrapper: headerWrapper,
	titleRow: titleRow,
	titleContent: titleContent,
	pageIcon: pageIcon,
	title: title,
	pageTag: pageTag,
	responsiveTag: responsiveTag,
	actionsContainer: actionsContainer,
	defaultActions: defaultActions,
	compactActions: compactActions,
	additionalContent: additionalContent
};

const PageHeader = ({ breadcrumbs, title, actions, compactActions, description, additionalContent, pageIcon, pageTag, pageIconColor = "inherit" }) => {
  return jsxRuntime.jsxs(PageHeader_PageHeaderBase.PageHeaderBase, { topRowContent: breadcrumbs, children: [jsxRuntime.jsxs("header", { className: styles.headerWrapper, "data-zds": true, children: [jsxRuntime.jsxs("div", { className: styles.titleRow, children: [jsxRuntime.jsxs("div", { className: styles.titleContent, children: [pageIcon && jsxRuntime.jsx("div", { className: styles.pageIcon, style: { fill: pageIconColor }, "data-zds": true, children: typeof pageIcon === "string" ? jsxRuntime.jsx(designSystem.Icon, { color: "inherit", size: "var(--page-icon-size)", name: pageIcon }) : pageIcon }), jsxRuntime.jsx(designSystem.Heading, { className: styles.title, children: title }), pageTag && jsxRuntime.jsx("div", { className: styles.pageTag, "data-zds": true, children: typeof pageTag === "string" ? jsxRuntime.jsx(designSystem.Tag, { variant: "simple", size: "x-small", className: styles.responsiveTag, children: pageTag }) : pageTag })] }), (actions !== null && actions !== void 0 ? actions : compactActions) && jsxRuntime.jsxs("div", { className: styles.actionsContainer, "data-zds": true, children: [compactActions && jsxRuntime.jsx("div", { className: styles.compactActions, children: compactActions }), actions && jsxRuntime.jsx("div", { className: styles.defaultActions, children: actions })] })] }), description && jsxRuntime.jsx(designSystem.Text, { tag: "p", type: "Body1Multiline", color: "GrayWarm9", style: { padding: "var(--zds-space-8) 0" }, children: description })] }), additionalContent && jsxRuntime.jsx("div", { className: styles.additionalContent, "data-zds": true, children: additionalContent })] });
};

exports.PageHeader = PageHeader;
//# sourceMappingURL=PageHeader.cjs.js.map
